<script setup>
import {onMounted, onUnmounted, ref} from "vue";
import smooth from "../lib/smooth";

const props = defineProps({
    orientation: String,
    iteration: Number,
});

const orientation = !props.orientation || props.orientation === 'left' ? 1 : 2;
const iteration = !props.iteration || 3;
const multiply = orientation % 2 ? 1 : -1;

const el = ref();

let position, wrapper, first_text;

const smoothCallback = async ({deltaY}) => {
    deltaY = Math.abs( deltaY );

    let new_position = position + ( deltaY );

    if ( orientation % 2 ) {
        if ( new_position >= 0 ) {
            new_position = first_text.offsetWidth * -1;
        }
    } else {
        const right_side_of_first_child = first_text.getBoundingClientRect().right;

        if ( right_side_of_first_child <= 0 ) {
            new_position = 0;
        }
    }

    position = new_position;
    wrapper.style.transform = "translate3d(" + (new_position * multiply) + "px,0px,0px)";
};

onMounted( () => {
    wrapper = el.value.firstElementChild;
    first_text = wrapper.firstElementChild;

    position = orientation % 2 ? first_text.offsetWidth * -1 : 0;

    smooth.add( smoothCallback );
} );

onUnmounted( () => {
    position = null;

    smooth.remove( smoothCallback );
} );
</script>

<template>
    <div ref="el" class="text-marquee | text-space-gray font-thin font-special uppercase whitespace-nowrap overflow-hidden max-w-full [&_strong]:font-normal [&_strong]:text-white
text-6xl
sm:text-7xl
md:text-8xl
lg:text-9xl
">
        <div class="flex flex-row will-change-transform">
            <template v-for="iteration in 3">
                <div class="
pl-16 pr-16
sm:pl-20 sm:pr-20
md:pl-24 md:pr-24
lg:pl-32 lg:pr-32
">
                    <slot></slot>
                </div>
            </template>
        </div>
    </div>
</template>